/**
 * Created by Viacheslav Romanov on 01.11.2026
 */

// aisensia games have no pre-level boosters and mostly no lives, so the shared table
// (pre-level boosters + unlimited lives) shrinks to a booster or two after substitution.
// Coins plus in-level boosters instead; in coins a hint is 650, a wand 1300, an eraser 1900
// and kit1 ($0.99) gives 700, so 1st place is worth about $6, 4th-10th about $1.
// 1st (4150 coins of value) is kept level with the $2.99 KingsCupOffer content (4000) so the prize does not outshine the paid offer.
RewardsConfig.KingsCup = [
    { hard: 300, boosters: { cheap: 1, medium: 1, expensive: 1 } },
    { hard: 300, boosters: { cheap: 2, medium: 1 } },
    { hard: 200, boosters: { cheap: 1, medium: 1 } },
    { hard: 100, boosters: { cheap: 1 } },
    { hard: 100, boosters: { cheap: 1 } },
    { hard: 100, boosters: { cheap: 1 } },
    { hard: 100, boosters: { cheap: 1 } },
    { hard: 100, boosters: { cheap: 1 } },
    { hard: 100, boosters: { cheap: 1 } },
    { hard: 100, boosters: { cheap: 1 } }
];
